import { render, staticRenderFns } from "./ipcShopping.vue?vue&type=template&id=79bbd050&scoped=true&"
import script from "./ipcShopping.vue?vue&type=script&lang=js&"
export * from "./ipcShopping.vue?vue&type=script&lang=js&"
import style0 from "./ipcShopping.vue?vue&type=style&index=0&id=79bbd050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bbd050",
  null
  
)

export default component.exports